/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import { Moment } from 'moment';

import { EFormatData } from '../../../../../pages/PageDashboard/types/widgetTypes';

export const getRangeDatePickerDateFilterValue = (leftRange?: Moment, rightRange?: Moment): string => {
    if (!leftRange || !rightRange) {
        return '';
    }
    const startMonth = leftRange.format(EFormatData.FullDataOnlyMonth);
    const startDay = leftRange.format(EFormatData.FullDataOnlyDay);
    const startYear = leftRange.format(EFormatData.FullDataOnlyYear);

    const endMonth = rightRange.format(EFormatData.FullDataOnlyMonth);
    const endDay = rightRange.format(EFormatData.FullDataOnlyDay);
    const endYear = rightRange.format(EFormatData.FullDataOnlyYear);

    const start = `${startDay}.${startMonth}.${startYear}`;
    const end = `${endDay}.${endMonth}.${endYear}`;
    return `${start} ... ${end}`;
};
